import { Component, OnInit, Input, ViewChild, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

import { CustomGridService } from './customgrid.service';
import { HtmlBase, HtmlButton } from '../models/global/class.global';
import { BObjectModel } from '../models/bodisplay';
import { CustomgridModel, CustomgridParam, CustomgridXml } from '../models/customgrid';
import { BreadcrumbService, CoreService, FilesManagerService, HttpService } from '../services';
import { ToastService } from '../toast';
import { DialogService } from '../dialog';
import { CustomGridItemService } from './customgrid-item/customgrid-item.service';
import { GridApi, RowNode, ColumnApi, ExcelExportParams, CsvExportParams, Column, CellValueChangedEvent, ICellEditorComp, ICellEditorParams, SelectionChangedEvent, RowClickedEvent, RowDoubleClickedEvent, CellClickedEvent, SortChangedEvent, FilterChangedEvent, GridReadyEvent, CellEvent, RowDataUpdatedEvent } from 'ag-grid-community';
declare let $: any;
import 'ag-grid-enterprise';
import { GetHeaderHeight } from '../utilities';
import { HttpClient } from '@angular/common/http';
import { extend } from 'jquery';
import { CheckboxEditor, ComboEditor, CheckboxRenderer, DatePickerEditor } from './agInput';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-customgrid',
  templateUrl: './customgrid.component.html',
  styleUrls: ['./customgrid.component.css']
})

export class CustomgridComponent implements OnInit {
  private customGridIdentUnique: number = Math.floor(Math.random() * 100000000000000);
  private GRID_PADDINGS: number = 30 + 16; // add 30px for the buttons' row + 16px for the mt-3 on grid's row
  private groupIncludeFooter: boolean;
  public GridXml: CustomgridXml;
  private footerData: any[] = [];
  private footerField: Array<any>;
  public customgridname: string = '';
  private customgridheightoffset: number;
  private customgridheight: string = '';
  private customgridheightPadding: number = 0;
  private customgridminheight: string = '160px';
  private iddonnee: string = '';
  private idbo: string = '';
  private idrelation: string = '';
  private completejoin: string = '';
  private completewhere: string = '';
  //private completeWhereApprox: string = '';
  private completeOrderBy: string = '';
  private completehaving: string = '';
  private moderecherche: boolean;
  private customgridparam: CustomgridModel;
  private isedition: boolean = false;


  public activebutton: HtmlBase[];
  public customgridStyle: any;
  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public gridOptions: any;
  public autoGroupColumnDef: any;
  public defaultColDef: any;

  public loadGrid: boolean = false;
  public isLoading: boolean = true;
  public gridHasRow: boolean = true;
  public modalElement: any = null;
  public dateToday: Date = new Date();
  public columnConfigKey: string;
  public autoSizeColumns: boolean = false;

  public showConfigButtons: boolean = true;



  @Input('autoSizeColumnsOnInit') set SetAutoSizeColumns(value: boolean) {
    this.autoSizeColumns = value;
  }

  @Input('configButtons') set SetConfigButtons(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.showConfigButtons = true;
    } else {
      this.showConfigButtons = value;
    }
  }

  public showExportButtons: boolean = true;
  @Input('exportButtons') set SetExportButtons(value: boolean | string) {
    if (typeof (value) === 'string') {
      if (value === '')
        this.showExportButtons = true;
    } else {
      this.showExportButtons = value;
    }
  }

  // list of buttons to display at the top of the component
  @Input() set activeButton(value: HtmlBase[]) { this.activebutton = value; }
  // xml configuration file name
  @Input() set customgridName(value: string) { this.customgridname = this.columnConfigKey = value ? value : ''; }
  // eventual offset to substract to height 100vh/window.innerHeight
  @Input() set customgridHeightOffset(value: number) {
    this.customgridheightoffset = value != null && value !== undefined ? value : GetHeaderHeight(this.indParam.Context);
    this.customgridheightoffset += this.GRID_PADDINGS;
  }
  // eventual height defined
  @Input() set customgridHeight(value: string) {
    this.customgridheight = !value ? `${GetHeaderHeight(this.indParam.Context)}px` : `${value}`;
    this.customgridheightPadding = this.GRID_PADDINGS + 32;
  }


  @Input() set customgridMinHeight(value: string) {
    this.customgridminheight = !value ? `160px` : `${value}`;
  }

  @Input() set idDonnee(value: string) { this.iddonnee = value ? value : ''; }
  @Input() set idBO(value: string) { this.idbo = value ? value : ''; }
  @Input() set idRelation(value: string) { this.idrelation = value ? value : ''; }
  @Input() set completeJoin(value: string) { this.completejoin = value ? value : ''; }
  @Input() set completeWhere(value: string) { this.completewhere = value ? value : ''; }
  @Input('CompleteOrderBy') set SetCompleteOrderBy(value: string) { this.completeOrderBy = value ? value : ''; }
  @Input() set completeHaving(value: string) { this.completehaving = value ? value : ''; }

  @Input() set modeRecherche(value: boolean) { this.moderecherche = value; }
  @Input() set customgridParam(value: CustomgridModel) { this.customgridparam = value; }
  @Input() set isEdition(value: boolean) { this.isedition = value; }
  @Input() set refreshData(value: boolean) {
    if (value) {
      this.getDataServer();
      setTimeout(() => { this.refreshDataChange.emit(false); }, 250);
    }
  }
  @Input() public isDashboard: string = '0';
  @Input() public InputData: string = '';

  @Input('updateValue') set UpdateValue(value: any) {
    if (value) {
      this.onUpdate(value);
    }
  }

  @Output() selectChanged: EventEmitter<SelectionChangedEvent> = new EventEmitter<SelectionChangedEvent>();
  @Output() rowClicked: EventEmitter<RowClickedEvent> = new EventEmitter<RowClickedEvent>();
  @Output() rowDoubleClicked: EventEmitter<RowDoubleClickedEvent> = new EventEmitter<RowDoubleClickedEvent>();
  @Output() cellClicked: EventEmitter<CellClickedEvent> = new EventEmitter<CellClickedEvent>();
  @Output() gridReady: EventEmitter<GridReadyEvent> = new EventEmitter<GridReadyEvent>();
  @Output() filterChanged: EventEmitter<FilterChangedEvent> = new EventEmitter<FilterChangedEvent>();
  @Output() sortChanged: EventEmitter<SortChangedEvent> = new EventEmitter<SortChangedEvent>();
  @Output() rowDataUpdated: EventEmitter<RowDataUpdatedEvent> = new EventEmitter<RowDataUpdatedEvent>();
  @Output() refreshDataChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() OutputModeRecherche: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() OutputRechercheApprox: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cellValueChanged: EventEmitter<CellValueChangedEvent> = new EventEmitter<CellValueChangedEvent>();


  @ViewChild('agGrid', { static: false }) agGrid: any;

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void { this.calcGridHeight(); }

  constructor(
    private indParam: CoreService,
    private http: HttpService,
    public gridservice: CustomGridService,
    private toastservice: ToastService,
    private dialog: DialogService,
    private customGridItemService: CustomGridItemService,
    private elRef: ElementRef,
    private httpcli: HttpClient,
    private fileService: FilesManagerService,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.isInQModal(this.elRef.nativeElement);
    this.getDataServer();
    this.customgridheightoffset = GetHeaderHeight(this.indParam.Context) + this.GRID_PADDINGS;
  }

  setClassBtn(btn: HtmlButton): string {
    const cls: string = 'btn actionBtn';
    if (!btn.Visible)
      return 'btn actionBtn hiddenBtn';

    switch (btn.ID.toUpperCase()) {
      case 'btnEnregistrer'.toUpperCase(): return `${cls} saveBtn`;
      case 'btnSupprimer'.toUpperCase(): return `${cls} removeBtn`;
      case 'btnModeCreer'.toUpperCase(): return `${cls} createBtn`;
      case 'btnImporter'.toUpperCase(): return `${cls} importBtn`;
      default: return cls;
    }
  }
  setClassBtnImg(btn: HtmlButton): string {
    switch (btn.ID.toUpperCase()) {
      case 'btnEnregistrer'.toUpperCase(): return `fas fa-save`;
      case 'btnSupprimer'.toUpperCase(): return `fas fa-trash-alt`;
      case 'btnModeCreer'.toUpperCase(): return `fas fa-plus-circle`;
      case 'btnImporter'.toUpperCase(): return `fas fa-search-plus`;
      default: return '';
    }
  }
  setBtnTip(btn: HtmlButton): string {
    switch (btn.ID.toUpperCase()) {
      case 'btnEnregistrer'.toUpperCase(): return `enregistrer`;
      case 'btnSupprimer'.toUpperCase(): return `supprimer`;
      case 'btnModeCreer'.toUpperCase(): return `creer`;
      case 'btnImporter'.toUpperCase(): return `Ajouter un élément existant`;
      default: return '';
    }
  }


  // #region ag-grid

  // Grid initialisée
  public onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.GridXml.rowData && this.GridXml.rowData.data !== '[]') {
      this.gridApi.setSideBarVisible(true);
      this.gridApi.closeToolPanel();
    } else {
      this.gridApi.setSideBarVisible(false);
    }

    if (this.groupIncludeFooter) {
      //  params.api.setPinnedBottomRowData(this.footerData);
      let pinnedBottomData = this.generatePinnedBottomData();
      this.gridApi.setPinnedBottomRowData([pinnedBottomData]);
    }
    if (this.autoSizeColumns) {
      setTimeout(() => {
        this.gridColumnApi.autoSizeAllColumns();
      }, 100);

    }
    //this.autoSizeAll();
    this.gridReady.emit(params);
    this.selectChanged.emit(params);


  }

  // Action sur filtre
  public OnFilterChanged(params: FilterChangedEvent): void {

    params.columnApi.getAllColumns()?.forEach(e => {
      this.recalculFooter(e);
    });

    this.filterChanged.emit(params);
  }

  // Action sur trie
  public OnSortChanged(params: SortChangedEvent): void {
    this.sortChanged.emit(params);
  }

  //Le client a mis à jour les données de la grille en
  //a) définissant de nouvelles données de ligne
  //b) en appliquant une transaction de ligne.
  public OnRowDataUpdated(event: RowDataUpdatedEvent): void {
    this.rowDataUpdated.emit(event);
  }

  // Action sur sélection
  public OnSelectionChanged(params: SelectionChangedEvent): void {
    this.selectChanged.emit(params);
  }

  // Action sur clic row
  public OnRowClicked(params: RowClickedEvent): void {
    this.rowClicked.emit(params);
  }

  //Action sur double clic row
  public OnRowDoubleClicked(params: RowDoubleClickedEvent): void {
    this.rowDoubleClicked.emit(params);
  }

  // Action sur clic cell
  public onCellClicked(params: CellClickedEvent): void {
    this.cellClicked.emit(params);
  }

  // #endregion

  // Gestion de la largeur des colonnes
  public onBtSizeColumn() {
    if (this.autoSizeColumns) {
      if (this.gridColumnApi) {
        //sizeToFit()
        this.gridApi.sizeColumnsToFit();
      }
    }
    else {
      // autoSizeAll()
      const allColumnIds: string[] = [];
      this.gridColumnApi.getAllColumns()!.forEach((column: any) => {
        allColumnIds.push(column.getId());
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
    this.autoSizeColumns = !this.autoSizeColumns;
  }

  // export excel au format .csv
  public onBtExport(): void {

    var dd = String(this.dateToday.getDate()).padStart(2, '0');
    var mm = String(this.dateToday.getMonth() + 1).padStart(2, '0');
    var yyyy = this.dateToday.getFullYear();
    var date = dd + '_' + mm + '_' + yyyy;

    const params: CsvExportParams = {
      skipHeader: false,
      columnGroups: false,
      skipGroups: true,
      skipPinnedTop: true,
      skipPinnedBottom: true,
      allColumns: true,
      onlySelected: false,
      suppressQuotes: false,
      fileName: `dataCustomGrid_` + date + `.csv`,
      columnSeparator: `;`,
      customHeader: `Entete`,
      customFooter: `Pied de page`
    };

    this.gridApi.exportDataAsCsv(params);
  }

  // export excel au format .xlsx
  public onBtExportExcel(): void {

    var dd = String(this.dateToday.getDate()).padStart(2, '0');
    var mm = String(this.dateToday.getMonth() + 1).padStart(2, '0');
    var yyyy = this.dateToday.getFullYear();
    var date = dd + '_' + mm + '_' + yyyy;

    const params: ExcelExportParams = {
      skipHeader: false,
      columnGroups: false,
      skipGroups: true,
      skipPinnedTop: true,
      skipPinnedBottom: true,
      allColumns: true,
      onlySelected: false,
      sheetName: 'customgrid',
      fileName: `dataCustomGrid_` + date + `.xlsx`
    };

    this.gridApi.exportDataAsExcel(params);
  }

  public OnCellValueChanged(event: CellValueChangedEvent): void {
    if (event.source == 'FooterRecalculation') return;
    this.recalculFooter(event.column);
    this.cellValueChanged.emit(event);
  }

  private recalculFooter(column: Column) {
    let newValue = this.calculFooterValue(column);
    if (!newValue) return;

    this.gridApi.getPinnedBottomRow(0)!.setDataValue(column.getColDef().field!, newValue, 'FooterRecalculation');
  }

  private calculFooterValue(column: Column) {
    let newValue: any;
    if (!(column as any).footerField) { return newValue }

    //check si la colonne a un footerField
    let colFooterField = /\[(.*?)\]/g.exec((column as any).footerField)
    if (!colFooterField) { return; }

    //recuperation des valeurs apres filter des rows de la colonne
    let rowValues: any[] = [];
    this.gridApi.forEachNodeAfterFilter((e: any) => {
      //check si la row a la colonne (c'est pour descriminer les footers des groupes)
      if (e?.data?.[column.getColId()]) {
        rowValues.push(e.data[column.getColId()!]);
      }
    });

    switch (colFooterField[0].toLocaleLowerCase()) {
      case '[sum]':
      case 'sum':
        newValue = rowValues.filter(Number).reduce((partialSum, currentValue) => partialSum + currentValue, 0);
        break;
      case '[avg]':
      case 'avg':
        newValue = rowValues.filter(Number).reduce((partialSum, currentValue, index) => partialSum + (currentValue - partialSum) / (index + 1), 0);

        break;
      case '[total]':
      case 'total':
        newValue = rowValues.length;
    }

    return (column as any).footerField.replace(`[${colFooterField[colFooterField.length - 1]}]`, this.limiterDecimales(newValue));
  }

  limiterDecimales(nombre: number) {
    if (Number.isInteger(nombre)) {
      return nombre;
    } else {
      return nombre.toFixed(2);
    }
  }


  // action au moment de la suppression ou de la modification d'un grid
  public action(button: HtmlBase): void {
    const btnID: string = button.ID;
    const model: BObjectModel = new BObjectModel;

    switch (btnID) {
      case 'btnSupprimer':
        const selectedNodes: RowNode[] = this.agGrid.api.getSelectedNodes();
        const selectedData: any = selectedNodes.map((node: RowNode) => node.data);
        if (selectedData.length === 0) {
          this.toastservice.showInfoToast(this.indParam.getTrad('ext_cg_noneSelected'));
        } else {
          let message: string = this.indParam.getTrad('ext_cg_removeLine');
          if (selectedData.length > 1) {
            // tslint:disable-next-line:max-line-length
            message = `${this.indParam.getTrad('ext_cg_confirm1')} ${selectedData.length} ${this.indParam.getTrad('ext_cg_confirm2')}?`;
          }
          const validRemove: boolean = confirm(message);
          // Liste des lignes a supprimer
          if (validRemove) {
            const selectedDataStringPresentation: any = selectedData.map((node: any) => node.Ident).join(',');

            model.IdentBO = this.customgridparam.cgParameters.IdBO;
            model.IdDonneeFils = selectedDataStringPresentation;
            model.IdRelation = this.customgridparam.cgParameters.IdRelation;
            model.IdDonneePere = this.customgridparam.cgParameters.IdDonnee;
            model.Mode = 'REMOVEBO';
            this.dialog.showSplash(true);
            this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).subscribe(
              (result: BObjectModel) => {
                this.dialog.showSplash(false);
                this.toastservice.showSuccessToast(result.Alert);
                this.getDataServer();
              });
          }
        }
        break;
      case 'btnModeCreer':
        model.IdentBO = this.customgridparam.cgParameters.IdBO;
        model.IdDonneeFils = `0`;
        model.IdRelation = this.customgridparam.cgParameters.IdRelation;
        model.IdDonneePere = this.customgridparam.cgParameters.IdDonnee;
        model.Mode = 'CREATE';
        model.ShowCreateButton = false;
        model.ShowRemoveButton = false;
        model.ShowSaveButton = true;
        model.Action = 'ANG_PAGE';

        this.gridservice.sendItem(this.customgridname, model);
        break;
      case 'btnImporter':
        model.IdentBO = this.customgridparam.cgParameters.IdBO;
        model.IdDonneeFils = `0`;
        model.IdRelation = this.customgridparam.cgParameters.IdRelation;
        model.IdDonneePere = this.customgridparam.cgParameters.IdDonnee;
        model.Mode = 'CREATE';
        model.ShowCreateButton = false;
        model.ShowRemoveButton = false;
        model.ShowSaveButton = true;
        model.Action = 'SEARCH_PAGE';

        this.gridservice.sendItem(this.customgridname, model);
        break;
    }
  }

  // Recupere les données du serveur (it needs to be public because it is used externally in listeModules.component.ts)
  public getDataServer(): void {

    //this.dialog.showSplash(true);
    if (this.customgridname === '') {
      // Le model est issu d'un input
      if (this.customgridparam) {
        if (this.customgridparam.cgParameters && !this.customgridparam.cgParameters.isDataLoaded) {
          this.customgridparam.Mode = 'INITDATA';
          this.http.postHttp<CustomgridModel>(`${this.indParam.AppParams.apiUrl}api/customgrid`, this.customgridparam).subscribe((data: CustomgridModel) => {
            if (data && data.cgParameters && data.cgParameters.FileName)
              this.columnConfigKey = data.cgParameters.FileName;
            this.initCustomGrid(data);
            this.isLoading = false;
          });
        } else {
          if (this.customgridparam && this.customgridparam.cgParameters && this.customgridparam.cgParameters.FileName)
            this.columnConfigKey = this.customgridparam.cgParameters.FileName;
          this.initCustomGrid(this.customgridparam);
          this.isLoading = false;
        }
      }
      else {
        this.isLoading = false;
      }
    } else {
      // S'il y a un FILTRE "WHERE / AND" sur la custoGrid -> récupération de la customgrid avec un POST : la requête peut être "interdite" en appel GET
      const model: CustomgridModel = new CustomgridModel();
      model.cgParameters = new CustomgridParam();
      model.cgParameters.Mode = 'INITDATA';
      model.cgParameters.FileName = this.customgridname;
      model.cgParameters.isEdition = this.isedition;
      model.cgParameters.IsDashboard = this.isDashboard === '1';
      model.cgParameters.IdDonnee = this.iddonnee;
      model.cgParameters.IdRelation = this.idrelation;
      model.cgParameters.CompleteJoin = (this.completejoin && this.completejoin !== '') ? this.completejoin : '';
      model.cgParameters.CompleteWhere = (this.completewhere && this.completewhere !== '') ? this.completewhere : '';
      //model.cgParameters.CompleteWhereApprox = (this.completeWhereApprox && this.completeWhereApprox! == '') ? this.completeWhereApprox : '';
      model.cgParameters.CompleteOrderBy = (this.completeOrderBy && this.completeOrderBy !== '') ? this.completeOrderBy : '';
      model.cgParameters.CompleteHaving = (this.completehaving && this.completehaving !== '') ? this.completehaving : '';
      model.cgParameters.InputData = this.InputData;
      if (this.customgridparam && this.customgridparam.cgParameters) {
        model.cgParameters.IdDonnee = this.customgridparam.cgParameters.IdDonnee;
        model.cgParameters.IdDonneeParent = this.customgridparam.cgParameters.IdDonneeParent ? this.customgridparam.cgParameters.IdDonneeParent : this.iddonnee;
        model.cgParameters.IdBOParent = this.customgridparam.cgParameters.IdBOParent ? this.customgridparam.cgParameters.IdBOParent : this.idbo;
      }

      //perte de l'url dans la fonction private envoyée à l'ag grid
      model.GridXml = new CustomgridXml();
      this.http.postHttp<CustomgridModel>(`${this.indParam.AppParams.apiUrl}api/customgrid`, model).subscribe((data: CustomgridModel) => {
        if (data && data.cgParameters && data.cgParameters.FileName && !this.isedition)
          this.columnConfigKey = data.cgParameters.FileName;
        this.initCustomGrid(data);
        this.isLoading = false;
      });

    }
  }

  // #region FONCTIONS PRIVEES

  // trad component initialization
  private initTrad(): any {
    return {
      andCondition: `${this.indParam.getTrad('andCondition')}`,
      applyFilter: `${this.indParam.getTrad('applyFilter')}`,
      areaChart: `${this.indParam.getTrad('areaChart')}`,
      areaRangeChart: `${this.indParam.getTrad('areaRangeChart')}`,
      autosizeAllColumns: `${this.indParam.getTrad('autosizeAllColumns')}`,
      autosizeThiscolumn: `${this.indParam.getTrad('autosizeThiscolumn')}`,
      average: `${this.indParam.getTrad('average')}`,
      axis: `${this.indParam.getTrad('axis')}`,
      barRangeChart: `${this.indParam.getTrad('barRangeChart')}`,
      blanks: `${this.indParam.getTrad('blanks')}`,
      blur: `${this.indParam.getTrad('blur')}`,
      bold: `${this.indParam.getTrad('bold')}`,
      boldItalic: `${this.indParam.getTrad('boldItalic')}`,
      bottom: `${this.indParam.getTrad('bottom')}`,
      callout: `${this.indParam.getTrad('callout')}`,
      categories: `${this.indParam.getTrad('categories')}`,
      chart: `${this.indParam.getTrad('chart')}`,
      chartRange: `${this.indParam.getTrad('chartRange')}`,
      collapseAll: `${this.indParam.getTrad('collapseAll')}`,
      color: `${this.indParam.getTrad('color')}`,
      columns: `${this.indParam.getTrad('columns')}`,
      columnRangeChart: `${this.indParam.getTrad('columnRangeChart')}`,
      contains: `${this.indParam.getTrad('contains')}`,
      copy: `${this.indParam.getTrad('copy')}`,
      copyWithHeaders: `${this.indParam.getTrad('copyWithHeaders')}`,
      count: `${this.indParam.getTrad('count')}`,
      csvExport: `${this.indParam.getTrad('csvExport')}`,
      ctrlC: `${this.indParam.getTrad('ctrlC')}`,
      ctrlV: `${this.indParam.getTrad('ctrlV')}`,
      data: `${this.indParam.getTrad('data')}`,
      doughnutChart: `${this.indParam.getTrad('doughnutChart')}`,
      doughnutTooltip: `${this.indParam.getTrad('doughnutTooltip')}`,
      egal: `${this.indParam.getTrad('egal')}`,
      endsWith: `${this.indParam.getTrad('endsWith')}`,
      equals: `${this.indParam.getTrad('eq')}`,
      excelExport: `${this.indParam.getTrad('excelExport')}`,
      excelXmlExport: `${this.indParam.getTrad('excelXmlExport')}`,
      expandAll: `${this.indParam.getTrad('expandAll')}`,
      export: `${this.indParam.getTrad('export')}`,
      fillOpacity: `${this.indParam.getTrad('fillOpacity')}`,
      filteredRows: `${this.indParam.getTrad('filteredRows')}`,
      filterOoo: `${this.indParam.getTrad('filterOoo')}`,
      filters: `${this.indParam.getTrad('filters')}`,
      first: `${this.indParam.getTrad('first')}`,
      font: `${this.indParam.getTrad('font')}`,
      format: `${this.indParam.getTrad('format')}`,
      greaterThan: `${this.indParam.getTrad('greaterThan')}`,
      greaterThanOrEqual: `${this.indParam.getTrad('greaterThanOrEqual')}`,
      group: `${this.indParam.getTrad('group')}`,
      groupBy: `${this.indParam.getTrad('groupBy')}`,
      groupedAreaTooltip: `${this.indParam.getTrad('groupedAreaTooltip')}`,
      groupedBarTooltip: `${this.indParam.getTrad('groupedBarTooltip')}`,
      groupedColumnChart: `${this.indParam.getTrad('groupedColumnChart')}`,
      groupedColumnTooltip: `${this.indParam.getTrad('groupedColumnTooltip')}`,
      groups: `${this.indParam.getTrad('groups')}`,
      inRange: `${this.indParam.getTrad('inRange')}`,
      italic: `${this.indParam.getTrad('italic')}`,
      itemPaddingX: `${this.indParam.getTrad('itemPaddingX')}`,
      itemPaddingY: `${this.indParam.getTrad('itemPaddingY')}`,
      labels: `${this.indParam.getTrad('labels')}`,
      last: `${this.indParam.getTrad('last')}`,
      left: `${this.indParam.getTrad('left')}`,
      length: `${this.indParam.getTrad('length')}`,
      legend: `${this.indParam.getTrad('legend')}`,
      lessThan: `${this.indParam.getTrad('lessThan')}`,
      lessThanOrEqual: `${this.indParam.getTrad('lessThanOrEqual')}`,
      lineRangeChart: `${this.indParam.getTrad('lineRangeChart')}`,
      lineTooltip: `${this.indParam.getTrad('lineTooltip')}`,
      lineWidth: `${this.indParam.getTrad('lineWidth')}`,
      loadingOoo: `${this.indParam.getTrad('loadingOoo')}`,
      markerPadding: `${this.indParam.getTrad('markerPadding')}`,
      markers: `${this.indParam.getTrad('markers')}`,
      markerSize: `${this.indParam.getTrad('markerSize')}`,
      markerStroke: `${this.indParam.getTrad('markerStroke')}`,
      max: `${this.indParam.getTrad('max')}`,
      min: `${this.indParam.getTrad('min')}`,
      more: `${this.indParam.getTrad('more')}`,
      next: `${this.indParam.getTrad('next')}`,
      none: `${this.indParam.getTrad('none')}`,
      noPin: `${this.indParam.getTrad('noPin')}`,
      normal: `${this.indParam.getTrad('normal')}`,
      normalizedAreaChart: `${this.indParam.getTrad('normalizedAreaChart')}`,
      normalizedAreaTooltip: `${this.indParam.getTrad('normalizedAreaTooltip')}`,
      normalizedBarChart: `${this.indParam.getTrad('normalizedBarChart')}`,
      normalizedBarTooltip: `${this.indParam.getTrad('normalizedBarTooltip')}`,
      normalizedColumnChart: `${this.indParam.getTrad('normalizedColumnChart')}`,
      normalizedColumnTooltip: `${this.indParam.getTrad('normalizedColumnTooltip')}`,
      noRowsToShow: `${this.indParam.getTrad('noRowsToShow')}`,
      notEqual: `${this.indParam.getTrad('notEquals')}`,
      notEquals: `${this.indParam.getTrad('notEquals')}`,
      notContains: `${this.indParam.getTrad('notContains')}`,
      of: `${this.indParam.getTrad('of')}`,
      offset: `${this.indParam.getTrad('offset')}`,
      offsets: `${this.indParam.getTrad('offsets')}`,
      orCondition: `${this.indParam.getTrad('orCondition')}`,
      padding: `${this.indParam.getTrad('padding')}`,
      Page: `${this.indParam.getTrad('Page')}`,
      paste: `${this.indParam.getTrad('paste')}`,
      pieChart: `${this.indParam.getTrad('pieChart')}`,
      pieRangeChart: `${this.indParam.getTrad('pieRangeChart')}`,
      pieTooltip: `${this.indParam.getTrad('pieTooltip')}`,
      pinColumn: `${this.indParam.getTrad('pinColumn')}`,
      pinLeft: `${this.indParam.getTrad('pinLeft')}`,
      pinRight: `${this.indParam.getTrad('pinRight')}`,
      pivotColumnsEmptyMessage: `${this.indParam.getTrad('pivotColumnsEmptyMessage')}`,
      pivotMode: `${this.indParam.getTrad('pivotMode')}`,
      pivots: `${this.indParam.getTrad('position')}`,
      position: `${this.indParam.getTrad('title')}`,
      previous: `${this.indParam.getTrad('previous')}`,
      resetColumns: `${this.indParam.getTrad('resetColumns')}`,
      right: `${this.indParam.getTrad('right')}`,
      rowGroupColumns: `${this.indParam.getTrad('rowGroupColumns')}`,
      rowGroupColumnsEmptyMessage: `${this.indParam.getTrad('rowGroupColumnsEmptyMessage')}`,
      searchOoo: `${this.indParam.getTrad('searchOoo')}`,
      selectAll: `${this.indParam.getTrad('selectAll')}`,
      selectedRows: `${this.indParam.getTrad('selectedRows')}`,
      series: `${this.indParam.getTrad('series')}`,
      settings: `${this.indParam.getTrad('settings')}`,
      shadow: `${this.indParam.getTrad('shadow')}`,
      size: `${this.indParam.getTrad('size')}`,
      stackedAreaChart: `${this.indParam.getTrad('stackedAreaChart')}`,
      stackedAreaTooltip: `${this.indParam.getTrad('stackedAreaTooltip')}`,
      stackedBarChart: `${this.indParam.getTrad('stackedBarChart')}`,
      stackedBarTooltip: `${this.indParam.getTrad('stackedBarTooltip')}`,
      stackedColumnChart: `${this.indParam.getTrad('stackedColumnChart')}`,
      stackedColumnTooltip: `${this.indParam.getTrad('stackedColumnTooltip')}`,
      startsWith: `${this.indParam.getTrad('startsWith')}`,
      strokeOpacity: `${this.indParam.getTrad('strokeOpacity')}`,
      strokeWidth: `${this.indParam.getTrad('strokeWidth')}`,
      sum: `${this.indParam.getTrad('sum')}`,
      thickness: `${this.indParam.getTrad('thickness')}`,
      ticks: `${this.indParam.getTrad('ticks')}`,
      title: `${this.indParam.getTrad('title')}`,
      to: `${this.indParam.getTrad('to')}`,
      toolPanel: `${this.indParam.getTrad('toolPanel')}`,
      toolPanelButton: `${this.indParam.getTrad('toolPanelButton')}`,
      tooltips: `${this.indParam.getTrad('tooltips')}`,
      top: `${this.indParam.getTrad('top')}`,
      totalAndFilteredRows: `${this.indParam.getTrad('totalAndFilteredRows')}`,
      totalRows: `${this.indParam.getTrad('totalRows')}`,
      ungroupBy: `${this.indParam.getTrad('ungroupBy')}`,
      valueAggregation: `${this.indParam.getTrad('valueAggregation')}`,
      valueColumns: `${this.indParam.getTrad('valueColumns')}`,
      valueColumnsEmptyMessage: `${this.indParam.getTrad('valueColumnsEmptyMessage')}`,
      values: `${this.indParam.getTrad('values')}`,
      width: `${this.indParam.getTrad('width')}`,
      xOffset: `${this.indParam.getTrad('xOffset')}`,
      yOffset: `${this.indParam.getTrad('yOffset')}`,
      xRotation: `${this.indParam.getTrad('xRotation')}`,
      yRotation: `${this.indParam.getTrad('yRotation')}`
    };
  }

  // Construction de la grid en fonction des données
  private initCustomGrid(data: CustomgridModel): void {
    const customgridModel: CustomgridModel = data;
    if ((customgridModel.GridXml?.rowFilter?._strTextSql && customgridModel.GridXml?.rowFilter?._strTextSql !== '')
      || (customgridModel.GridXml?.titre && customgridModel.GridXml?.titre !== '')) {
      this.customgridheightoffset += 90;
      this.customgridheightPadding += 90
    }

    this.configOption(customgridModel.GridXml);

    // C'est ultra moche ;p
    if (this.gridApi) {
      class selectionChanged implements SelectionChangedEvent {
        api: GridApi;
        columnApi: ColumnApi;
        type: string;
        context: any;
      }
      let selectionChangedToEmit: selectionChanged = new selectionChanged();
      selectionChangedToEmit.api = this.gridApi
      this.selectChanged.emit(selectionChangedToEmit);
    }


    // ---------- this is a trick to refresh grid data rows in case they are changed ----------
    this.loadGrid = false;
    setTimeout(() => { this.loadGrid = true; }, 1);
    // ----------------------------------------------------------------------------------------

    //this.dialog.showSplash(false);


  }


  defaultExcelExportParams: any;

  private configOption(GridXml: CustomgridXml): void {
    if (GridXml) {

      this.GridXml = GridXml;
      // this.GridXml.paginationPageSize = this.GridXml.paginationPageSize === 0 ? 10 : this.GridXml.paginationPageSize;





      this.groupIncludeFooter = GridXml.groupIncludeFooter;
      // Ensemble des colonnes de la grid
      const columnDefs: any[] = GridXml.columnDefs;
      // Gestion de composant (button image dans la grid)


      /*  this.defaultExcelExportParams = {
          autoConvertFormulas: true, // instead of dataType='Formula'
          processCellCallback: (params:any) => {
            //const rowIndex = params.accumulatedRowIndex;
            //const valueGetter = params.column.getColDef().valueGetter;
            return params.column.colDef.cellRenderer  ? '' : params.value;
          }
        };*/

      for (let i: number = 0; i < columnDefs.length; i++) {

        switch (columnDefs[i].cellEditor) {
          case "Combo":
            if (columnDefs[i].cellEditorParams) {
              columnDefs[i].cellEditorParams = { param: JSON.parse(columnDefs[i].cellEditorParams) };
            }
            break;
          default:
            break;
        }

        //empeche de rendre modifiable les row pinned (footer)
        if (columnDefs[i].editable) {
          columnDefs[i].editable = (params: any) => { return !params.node.isRowPinned() }
        }

        switch (columnDefs[i].cellEditor) {
          case 'Combo':
            columnDefs[i].cellRenderer = this.customGridItemService.ComboRenderer;
            break;
          default: break;
        }

        if (columnDefs[i].type) {
          switch (columnDefs[i].type && columnDefs[i].type.toLowerCase()) {
            case 'date':
            case 'dateshort':
            case 'datelong':
            case 'datetime':
              columnDefs[i].comparator = this.customGridItemService.dateComparator;
              columnDefs[i].valueFormatter = this.customGridItemService.dateFormatter(columnDefs[i].field, columnDefs[i].type.toLowerCase(), this.indParam.AppParams.culture);
              columnDefs[i].type = '';
              columnDefs[i].filterParams = this.customGridItemService.filterParams;
              break;
            case 'decimal':
              if (!this.groupIncludeFooter) {
                columnDefs[i].type = '';
              }
              columnDefs[i].cellRenderer = this.customGridItemService.DecimalRenderer;
              columnDefs[i].comparator = this.customGridItemService.DecimalComparator;
              break;
            case 'number':
              if (!this.groupIncludeFooter) {
                columnDefs[i].type = '';
              }
              columnDefs[i].cellRenderer = this.customGridItemService.NumberRenderer;
              columnDefs[i].comparator = this.customGridItemService.DecimalComparator;
              break;
            case 'monetary':
              if (!this.groupIncludeFooter) {
                columnDefs[i].type = '';
              }
              columnDefs[i].valueParser = (params: any) => isNaN(Number(params.newValue)) ? 0 : Number(params.newValue);
              columnDefs[i].cellRenderer = (params: any) => this.customGridItemService.MonetaryRenderer(params, this.indParam);
              columnDefs[i].comparator = this.customGridItemService.DecimalComparator;
              break;
            default:
              columnDefs[i].comparator = this.customGridItemService.StringComparator;
              break;
          }
        }

        if (columnDefs[i].cellRendererFrameworkObject) {
          if (columnDefs[i].cellRendererFrameworkObject.type) {
            const _itemsRenderer: any = this.customGridItemService.ItemsRenderer(this.indParam, this.gridservice, this.fileService, this.http, this.breadcrumbService, i, this.customgridname, this.customGridIdentUnique);
            columnDefs[i].cellRenderer = _itemsRenderer;
            columnDefs[i].filterValueGetter = ((params: any) => {
              const param: string = params.data[columnDefs[i].field];
              const paramArray: Array<string> = param.split(`|`);
              if (paramArray[0] === "FONT") {
                return paramArray.length > 2 && paramArray[2] ? paramArray[2] : paramArray[1];
              } else {
                return paramArray.length > 4 ? paramArray[4].replace(/\r?\n|\r/g, ' ') : param;
              }
            });
          }
        }
        if (columnDefs[i].cellStyle) {
          columnDefs[i].cellStyle = eval("(" + columnDefs[i].cellStyle + ")");
        }
        if (columnDefs[i].cellClassRules) {
          columnDefs[i].cellClassRules = eval("(" + columnDefs[i].cellClassRules + ")");
        }
      }


      this.footerField = [];
      // delete no-natif agGrid property col
      columnDefs.forEach((col: any) => {
        this.footerField.push({ fild: col.field, footerField: col.footerField })

        if (col.headerCheckboxSelection) {
          col.headerCheckboxSelectionFilteredOnly = true;
        }
        delete col.showDashBoard;
        delete col.codeName;
        delete col.codeTooltip;
        delete col.fieldselect;
        delete col.isCustomComponent;
        delete col.footerField;
        delete col.cellRendererFrameworkObject;


        col = Object.keys(col).reduce((obj: any, key: any) => {
          obj = col;
          if (!col[key] || col[key] == null || col[key] === undefined) {
            delete obj[key];
          }
          return obj;
        });



      });

      let hasFooterField = this.footerField.some(x => x.footerField);
      this.groupIncludeFooter = this.groupIncludeFooter ? this.groupIncludeFooter : hasFooterField;
      GridXml.groupIncludeTotalFooter = hasFooterField ? false : GridXml.groupIncludeTotalFooter;

      this.gridOptions = {
        components: {
          'DatePicker': DatePickerEditor,
          'CheckBox': CheckboxEditor,
          'Combo': ComboEditor,
        },
        frameworkComponents: {
          'CheckBoxRenderer': CheckboxRenderer,
        },
        defaultColDef: {
          filter: GridXml.enableFilter,
          resizable: GridXml.enableColResize,
          sortable: GridXml.enableSorting,
          enableValue: true,
          //enableRowGroup: true, 
          enablePivot: true,
          flex: 1,
          //minWidth: 150,
        },
        rowSelection: GridXml.rowSelection,
        pagination: GridXml.pagination,
        paginationAutoPageSize: GridXml.paginationAutoPageSize,
        rowHeight: GridXml.rowHeight,
        rowData: GridXml.rowData && GridXml.rowData.data ? JSON.parse(GridXml.rowData.data) : null,
        sideBar: GridXml.sideBar,
        enableCharts: GridXml.enableCharts,
        enableRangeSelection: true,
        animateRows: true,
        stopEditingWhenCellsLoseFocus: true,

        suppressAggFuncInHeader: true,
        suppressCopyRowsToClipboard: true,
        suppressRowClickSelection: GridXml.suppressRowClickSelection,
        showOpenedGroup: GridXml.showOpenedGroup,

        //groupMultiAutoColumn: true, //deprecated, now use 'groupDisplayType : multipleColumns'
        groupDisplayType: 'multipleColumns',
        groupDefaultExpanded: GridXml.groupDefaultExpanded,
        groupSelectsChildren: GridXml.groupSelectsChildren,

        groupHideOpenParents: GridXml.groupHideOpenParents,
        groupIncludeFooter: GridXml.groupIncludeFooter,
        groupIncludeTotalFooter: GridXml.groupIncludeTotalFooter,

        columnDefs: columnDefs,
        singleClickEdit: GridXml.singleClickEdit,
        localeText: this.initTrad()
      };

      this.autoGroupColumnDef = {
        minWidth: 200,
      };

      if (GridXml.paginationPageSize !== 0) {
        this.gridOptions.paginationAutoPageSize = false;
        this.gridOptions.paginationPageSize = GridXml.paginationPageSize;
      }
      //Commenté le 8/11 demande de bruno
      ////cas mode recherche approximative
      //if (GridXml.modeRecherche) {
      //  this.OutputModeRecherche.emit(GridXml.modeRecherche);
      //  GridXml.rechercheApprox = false;
      //} if (GridXml.rechercheApprox) {
      //  this.OutputRechercheApprox.emit(GridXml.rechercheApprox);
      //}
      this.calcGridHeight();
    }
  }

  // Calcul de la hauteur
  private calcGridHeight(): void {
    if (this.isDashboard === '1') {
      this.customgridStyle = { width: '100%', height: '100%' };
      return;
    }
    if (this.modalElement != null) {
      this.customgridStyle = { width: '100%', height: `calc(${this.modalElement.offsetHeight}px - ${this.customgridheightoffset}px)` };
      return;
    }

    const dt: any = JSON.parse(this.GridXml.rowData.data);
    this.gridHasRow = dt && dt.length > 0;
    if (!this.gridHasRow)
      return;

    const rowHeight: number = this.GridXml.rowHeight && this.GridXml.rowHeight > 0 ? this.GridXml.rowHeight : 28;
    // let totRows: number = this.GridXml.groupIncludeFooter ? 1 : 0;
    let totRows: number = 0;
    // Taille initiale prenant en compte l'espace pour la scrollbar horizontale (17) + le footer (s'il existe) + le Header
    let calcHeight: number = 17;
    calcHeight += this.groupIncludeFooter ? rowHeight : 0;
    // L'entête de la grid : 32px par défaut
    calcHeight += 32;

    // 3 façon de calculer la hauteur de la grid :

    // 1- CustomHeight est renseigné -> la grid prend cette hauteur (en px) : gridHeight = customHeight
    if (this.GridXml.customHeight && this.GridXml.customHeight !== 0) {
      calcHeight += this.GridXml.customHeight;
      this.customgridStyle = { width: '100%', height: `${calcHeight}px` };
    }

    // 2- Avec la pagination
    else {
      if (this.GridXml.pagination) {
        //2-a paginationPageSize est renseigné -> gridHeight = rowHeight * paginationPageSize
        if (this.GridXml.paginationPageSize && this.GridXml.paginationPageSize !== 0) {
          calcHeight += this.GridXml.paginationPageSize * rowHeight;
          this.customgridStyle = { width: '100%', height: `${calcHeight}px` };
        }
        else {
          //2-b adaptHeight est renseigné à true -> gridHeight = rowHeight * nbRows --- max-height = 100vh - customgridheightoffset
          if (this.GridXml.adaptHeight) {
            totRows = dt.length;
            calcHeight += rowHeight * (totRows + 1);
            // Modif du 20/07/22 -> passage de la taille min de 160 à 300px
            this.customgridStyle = { width: '100%', height: `${calcHeight}px`, 'max-height': `calc(100vh - ${this.customgridheightoffset}px)`, 'min-height': this.customgridminheight };
          }
          //2-c-1 taille par défaut -> gridHeight = customgridheight - padings
          else if (this.customgridheight) {
            this.customgridStyle = {
              width: '100%', height: `calc(${this.customgridheight.replace('calc', '')} - ${this.customgridheightPadding}px)`
            };
          }
          else {
            //2-c-2 taille par défaut -> gridHeight = 100vh - customgridheightoffset
            this.customgridStyle = { width: '100%', height: `calc(100vh - ${this.customgridheightoffset}px)`, 'min-height': this.customgridminheight };
          }

        }
      }
      else {
        // 3- Sans pagination, avec AdaptHeight -> gridHeight = rowHeight * nbRows --- max-height = 100vh - customgridheightoffset
        if (this.GridXml.adaptHeight) {
          totRows = dt.length;
          calcHeight += rowHeight * totRows;
          this.customgridStyle = { width: '100%', height: `${calcHeight}px`, 'max-height': `calc(100vh - ${this.customgridheightoffset}px)`, 'min-height': this.customgridminheight };
        }
        //2-c-1 taille par défaut -> gridHeight = customgridheight - padings
        else if (this.customgridheight) {
          this.customgridStyle = { width: '100%', height: `calc(${this.customgridheight.replace('calc', '')} - ${this.customgridheightPadding}px)` };
        }
        else {
          //2-c-2 taille par défaut -> gridHeight = 100vh - customgridheightoffset
          this.customgridStyle = { width: '100%', height: `calc(100vh - ${this.customgridheightoffset}px)`, 'min-height': this.customgridminheight };
        }

      }
    }
  }

  // check si la grid est dans une QModal
  private isInQModal(el: any): void {
    if (el.parentElement != null) {
      if (el.parentElement.classList.contains('custom-modal-content')) {
        this.modalElement = el.parentElement;
      } else {
        this.isInQModal(el.parentElement);
      }
    }
  }

  // #endregion



  generatePinnedBottomData() {

    let colIterator = 0;
    this.gridColumnApi.getAllColumns()?.forEach((col: any) => {
      col.footerField = this.footerField[colIterator].footerField;
      colIterator++;
    });

    // generate a row-data with null values
    let result: any = {};

    this.gridColumnApi.getAllGridColumns().forEach((item: any) => {
      result[item.colId] = null;
    });
    return this.calculatePinnedBottomData(result);
  }


  calculatePinnedBottomData(target: any) {
    this.gridColumnApi.getAllGridColumns().forEach((col: any) => {
      let newValue = this.calculFooterValue(col);
      if (!newValue) return;

      target[col.getColId()] = newValue;
    });

    target.isFooter = true;
    return target;
  }

  onUpdate(newData: any) {
    const api = this.gridApi;
    if (!api) return;

    api.forEachNode((row: any) => {
      let ident = row.data.ident || row.data.Ident;
      let newRow = newData.find((e: any) => { return e.ident == ident || e.Ident == ident });
      if (!newRow) return;

      for (const key in newRow) {
        row.data[key] = newRow[key];
      }   
      api.applyTransaction({ update: [row.data] });
    });   
  }
}

